import { render } from "./RefundDetail.vue?vue&type=template&id=d2daa1aa&scoped=true"
import script from "./RefundDetail.vue?vue&type=script&lang=js"
export * from "./RefundDetail.vue?vue&type=script&lang=js"

import "./RefundDetail.vue?vue&type=style&index=0&id=d2daa1aa&lang=scss&scoped=true"

import exportComponent from "F:\\ds_pc_new\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2daa1aa"]])

export default __exports__